import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorCategories } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const WAZEALERTS_LAYER_ID = 'wazeAlertsLayer';

// Updated LABELS to align with INCIDENT_TYPE_MAPPING values.
// INCIDENT_TYPE_MAPPING = {
//   ACCIDENT: 'Collision',
//   HAZARD: 'Hazard',
//   JAM: 'Congestion',
//   ROAD_CLOSED: 'Road Closure',
//   WEATHERHAZARD: 'Weather Hazard'
// }
const LABELS = [
  'Congestion',
  'Collision',
  'Hazard',
  'Road Closure',
  'Weather Hazard',
];

// Hex -> RGB mapping supplied:
// congestion: rgba(116, 78, 161, 1), collision: rgba(35, 96, 220, 1), hazard, weather hazard: rgba(236, 182, 0, 1), road closure: rgba(222, 61, 115, 1)
const COLORS = [
  [116, 78, 161],   // Congestion (#744EA1)
  [35, 96, 220],   // Collision (#2360DC)
  [236, 182, 0],    // Hazard (#ECB600)
  [222, 61, 115],   // Road Closure (#DE3D73)
  [236, 182, 0],    // Weather Hazard (#ECB600)
];

const layerConfig = {
  title: 'Waze Alerts'
};

function WazeAlertsLayer() {
    const dispatch = useDispatch();
    const { wazeAlertsLayer } = useSelector((state) => state.carto.layers);
    const source = useSelector((state) =>
        selectSourceById(state, wazeAlertsLayer?.source)
    );
    const cartoLayerProps = useCartoLayerProps({ source });
    const viewState = useSelector((state) => state.carto.viewState);
    const pointRadiusMinPixels = viewState.zoom >= 7 ? 4 : 2;

    if (wazeAlertsLayer && source) {
        return new CartoLayer({
        ...cartoLayerProps,
        id: WAZEALERTS_LAYER_ID,

        stroked: false,
        pointRadiusUnits: 'pixels',
        lineWidthUnits: 'pixels',
        pickable: true,
        visible: wazeAlertsLayer.visible,
        opacity: wazeAlertsLayer.opacity,
        pointRadiusMinPixels: pointRadiusMinPixels,
        
        getFillColor: colorCategories({
            attr: 'Incident_Type',
            domain: LABELS,
            colors: COLORS,
        }),
        onDataLoad: (data) => {
            dispatch(
                updateLayer({
                    id: WAZEALERTS_LAYER_ID,
                    layerAttributes: { ...layerConfig },
                })
            );
            cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
        },

        onHover: (info) => {
            if (info?.object) {
                info.object = {
                    html: htmlForFeature({
                    feature: info.object,
                    //includeColumns: ['Facility_Type', 'Facility_Name'], 
                    title: 'Waze Alert', 
                    }),
                };
            }
        },     
    });
  }
}

export default WazeAlertsLayer;